import { AvailableStaff } from '@spike/available-staff-model';
import clsx from 'clsx';
import Spinner from 'components/UI/V3/Spinner';
import { FunctionComponent, useState } from 'react';
import styles from './DropDown.module.scss';
import DropDownHeader from './DropDownHeader';
import DropDownItem from './DropDownItem';

interface DropDownProps {
    selectedId: number | null;
    selectedAvatar: string | null;
    selectedStaffName: string | null;
    availableStaff: Array<AvailableStaff>;
    x: number;
    y: number;
    loading?: boolean;
    className?: string;
    onClick?: (staff: AvailableStaff | null) => void;
}

export const DropDown: FunctionComponent<DropDownProps> = props => {
    const [search, setSearch] = useState('');

    const windowHeight = window.innerHeight;
    const dropDownDirection = props.y / windowHeight > 0.75 ? 'up' : 'down';
    const containerStyle =
        dropDownDirection === 'down'
            ? { left: props.x, top: props.y }
            : { left: props.x, bottom: windowHeight - props.y - 40 };

    const filteredStaff = props.availableStaff.filter(staff => {
        if (staff.id === props.selectedId) return false;
        if (!search.trim()) return true;
        const full = `${staff.firstName} ${staff.lastName}`.toLowerCase();
        return full.includes(search.trim().toLowerCase());
    });

    return (
        <div
            className={clsx(styles.container, props.className)}
            style={containerStyle}
        >
            {props.loading ? (
                <div className={styles.spinnerContainer}>
                    <Spinner size={24} />
                </div>
            ) : (
                <>
                    <DropDownHeader
                        selectedAvatar={props.selectedAvatar}
                        selectedStaffName={props.selectedStaffName}
                        onChange={setSearch}
                    />
                    {props.selectedId !== null && (
                        <DropDownItem
                            avatar={null}
                            staffName={'Unassigned'}
                            onClick={() => props.onClick?.(null)}
                        />
                    )}
                    {filteredStaff.map(staff => (
                        <DropDownItem
                            key={staff.id}
                            avatar={staff.avatar}
                            staffName={`${staff.firstName} ${staff.lastName}`}
                            onClick={() => props.onClick?.(staff)}
                        />
                    ))}
                </>
            )}
        </div>
    );
};

export default DropDown;
